import React, { useMemo } from "react";
import { View } from "react-native";
import { Table } from "@lookiero/aurora";
import { useI18n, useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { Modal } from "@lookiero/sty-psp-ui";
import { I18nMessages } from "../../../../../../../../../../i18n/i18n";
import { style as menSizeGuideModal } from "../men/MenSizeGuideModal.style";
import { LEG_LENGTH_SIZES, SIZES } from "./OutfitteryWomenSizeGuideModal.constants";
const OutfitteryWomenSizeGuideModal = ({ visible, domain, segment, i18nPrefix, portalHostName, onClose, }) => {
    const style = useMemo(() => menSizeGuideModal(), []);
    const { locale } = useI18n({ domain });
    const modalTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_MODAL_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const sizeTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_SIZE_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const jeansTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_JEANS_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const chestTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_CHEST_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const waistTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_WAIST_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const hipTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_HIP_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const legLenghtTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LEG_LENGTH_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const lengthTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LENGTH_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const legLengthTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LEG_LENGTH_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const heightTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_HEIGHT_HEADER_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoSubtitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_HOWTO_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoChestTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_CHEST_HOWTO_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoChestText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_CHEST_HOWTO_TEXT,
        values: { segment: segment.toLowerCase() },
    });
    const howtoWaistTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_WAIST_HOWTO_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoWaistText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_WAIST_HOWTO_TEXT,
        values: { segment: segment.toLowerCase() },
    });
    const howtoHipTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_HIP_HOWTO_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoHipText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_HIP_HOWTO_TEXT,
        values: { segment: segment.toLowerCase() },
    });
    const howtoLegLengthTitle = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LEG_LENGTH_HOWTO_TITLE,
        values: { segment: segment.toLowerCase() },
    });
    const howtoLegLengthText = useI18nMessage({
        domain,
        prefix: i18nPrefix,
        id: I18nMessages.SILHOUETTE_SIZES_GUIDE_LEG_LENGTH_HOWTO_TEXT,
        values: { segment: segment.toLowerCase() },
    });
    return (React.createElement(Modal, { portalHostName: portalHostName, testID: "size-guide-modal", visible: visible, scroll: true, showCloseButton: true, onClose: onClose },
        React.createElement(View, { style: style.modal },
            React.createElement(Text, { level: 1, variant: "action" }, modalTitle),
            React.createElement(Table
            // @ts-ignore
            , { 
                // @ts-ignore
                dataSource: SIZES[locale] || SIZES.default, style: style.modalGap, schema: {
                    size: sizeTitle,
                    jeans: jeansTitle,
                    bust: chestTitle,
                    waist: waistTitle,
                    hip: hipTitle,
                } }),
            React.createElement(Text, { level: 1, style: style.modalGap, variant: "action" }, legLenghtTitle),
            React.createElement(Table
            // @ts-ignore
            , { 
                // @ts-ignore
                dataSource: LEG_LENGTH_SIZES[locale] || LEG_LENGTH_SIZES.default, style: style.modalGap, schema: {
                    length: lengthTitle,
                    legLength: legLengthTitle,
                    height: heightTitle,
                } }),
            React.createElement(Text, { level: 1, style: style.modalGap, variant: "action" }, howtoSubtitle),
            React.createElement(View, { style: style.modalGap },
                React.createElement(Text, { level: 3, variant: "action" }, howtoChestTitle),
                React.createElement(Text, { level: 3, style: style.description }, howtoChestText)),
            React.createElement(View, { style: style.modalGap },
                React.createElement(Text, { level: 3, variant: "action" }, howtoWaistTitle),
                React.createElement(Text, { level: 3, style: style.description }, howtoWaistText)),
            React.createElement(View, { style: style.modalGap },
                React.createElement(Text, { level: 3, variant: "action" }, howtoHipTitle),
                React.createElement(Text, { level: 3, style: style.description }, howtoHipText)),
            React.createElement(View, { style: style.modalGap },
                React.createElement(Text, { level: 3, variant: "action" }, howtoLegLengthTitle),
                React.createElement(Text, { level: 3, style: style.description }, howtoLegLengthText)))));
};
export { OutfitteryWomenSizeGuideModal };
